import {
  HStack,
  Icon,
  Image,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import {
  RiFacebookCircleFill,
  RiInstagramFill,
  RiMailLine,
  RiMapPin2Line,
  RiWhatsappFill,
  RiYoutubeFill,
} from "@remixicon/react";
import logo from "../assets/logo.png";
import { useBgBaseColor } from "../themes/colors";
import { Link } from "react-router-dom";

const Footer = () => {
  const bgBase = useBgBaseColor();
  const mediaColor = useColorModeValue("gray.800", "gray.200");

  return (
    <VStack
      className="root-footer"
      bg={bgBase}
      w={"100%"}
      p={10}
      pb={2}
      mt={20}
      letterSpacing={0.5}
    >
      <Stack w={"100%"} flexDir={["column", null, null, "row", "row"]} gap={6}>
        <VStack
          className="left-container"
          gap={{ base: 8, md: 4 }}
          align={{ base: "center", md: "stretch" }}
          flex={1}
        >
          <HStack color={mediaColor} fontWeight="bold">
            <Image boxSize={"30px"} src={logo} alt="logo" />
            <Text letterSpacing={1} fontSize={{ base: "lg", md: "xl" }}>
              BisnisLink.id
            </Text>
          </HStack>

          <HStack align={"start"} w={"100%"} wrap={"wrap"} color={mediaColor}>
            <Icon as={RiMapPin2Line} boxSize={5} />
            <Stack spacing={1} maxW={"25ch"}>
              <Text as="b" fontSize={14}>
                BisnisLink Head Office
              </Text>
              <Text fontSize={12}>
                Potrowanen, RT 04 / RW 02 Donohudan, Ngemplak, Boyolali 57375
                Indonesia
              </Text>
            </Stack>
          </HStack>

          <HStack align={"start"} w={"100%"} wrap={"wrap"} color={mediaColor}>
            <Icon as={RiMailLine} boxSize={5} />
            <Text fontSize={12}>
              <a href="mailto:support@bisnislink.id">support@bisnislink.id</a>
            </Text>
          </HStack>

          <HStack
            w={"100%"}
            wrap={"wrap"}
            color={mediaColor}
            justify={{ base: "center", md: "start" }}
          >
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon as={RiInstagramFill} boxSize={"24px"} />
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon as={RiFacebookCircleFill} boxSize={"24px"} />
            </a>
            <a
              href="https://www.youtube.com/@TaniLinkTV"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon as={RiYoutubeFill} boxSize={"28px"} />
            </a>

            <a
              href="https://api.whatsapp.com/send?phone=6285647000377"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon as={RiWhatsappFill} boxSize={"24px"} />
            </a>
          </HStack>
        </VStack>

        <Stack
          className="wrap-both-container"
          direction={{ base: "column", md: "row" }}
          gap={8}
          flex={1}
          alignItems={{ base: "center", md: "start" }}
          color={mediaColor}
        >
          <VStack
            className="center-container"
            align={{ base: "center", md: "stretch" }}
            flex={1}
            fontSize="sm"
          >
            <Text textStyle={"h-reg-title"} fontSize="md">
              Tentang Kami
            </Text>
            <Text as={Link} to="/about">
              Tentang BisnisLink
            </Text>
            <Text as={Link} to="/faq">
              FAQ
            </Text>
            <Text as={Link} to="/guide/reseller">
              Panduan Reseller
            </Text>
            <Text as={Link} to="/guide/supplier">
              Panduan Supplier
            </Text>
            <Text as={Link} to="/terms-and-conditions">
              Syarat & Ketentuan
            </Text>
            <Text as={Link} to="/privacy-policy">
              Kebijakan Privasi
            </Text>
          </VStack>

          <VStack
            className="right-container"
            align={{ base: "center", md: "stretch" }}
            flex={1}
            fontSize="sm"
          >
            <Text textStyle={"h-reg-title"} fontSize="md">
              Informasi Lainnya
            </Text>
            <Text as={Link} to="/blog">
              Baca Berita Terbaru
            </Text>
            <Text as={Link} to="/register">
              Gabung Jadi Reseller
            </Text>
            <Text as={Link} to="/register">
              Daftar Distributor
            </Text>
            <Text as={Link} to="/contact">
              Layanan Pengaduan
            </Text>
          </VStack>
        </Stack>
      </Stack>
      <Text mt={8} fontSize="xs" color={mediaColor}>
        © 2025 BisnisLink.id. All rights reserved.
      </Text>
    </VStack>
  );
};

export default Footer;
